import { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_POPOVER_PLACEMENTS = {
  TopStart: "top-start",
  TopEnd: "top-end",
  BottomStart: "bottom-start",
  BottomEnd: "bottom-end",
  LeftStart: "left-start",
  RightStart: "right-start",
};

export type DSPopoverPlacement = ObjectValues<typeof DS_POPOVER_PLACEMENTS>;

export interface DSPopoverProps {
  offset?: number;
  placement?: DSPopoverPlacement;
  inheritActivatorWidth?: boolean;
}
